module.exports = __webpack_public_path__ + "img/gold_symbol_0.3009004c.png";